export const FS_FIELD_REASON_MESSAGES: Record<string, string> = {
    dateofbirth: 'Enter a valid date, no later than today, and no more than 100 years ago.',
    ssn: 'Must be between 9 and 11 characters and cannot be all repeating digits.',
    taxid: 'Not a valid Tax ID Number.',
    checkingaccount: 'Not a valid account number.',
    firstname: 'Must be 2–15 characters (letters, spaces, apostrophes, hyphens only).',
    lastname: 'Must be 2–25 characters (letters, spaces, apostrophes, hyphens only).',
    otherphone: 'Must be a 10-digit phone number and cannot be a toll-free number or contain the 555 prefix.',
    phone: 'Must be a 10-digit phone number and cannot be a toll-free number or contain the 555 prefix.',
    email: 'Must be a valid email address and no more than 50 characters.',
    driverslicensenumber: 'Must be between 1 and 15 characters, letters and digits only.',
    driverslicensestate: 'Must be a valid U.S. state, territory, or military mailing code.',

    stocknumber: 'Must be between 1 and 15 characters.',
    vin: 'Must be exactly 17 characters.',

    othertrim: 'Must be between 1 and 50 characters.',
    lienholdername: 'Must be between 2 and 30 characters. Use letters, numbers, spaces, & and . only.',
    nettrade: 'Amount must be between -$999,999 and $999,999. Please adjust Allowance or Payoff.',

    gap: 'Price must be between $0 and $999,999.',
    warranty: 'Price must be between $0 and $999,999.',
    creditlifeins: 'Price must be between $0 and $999,999.',
    accidenthealthins: 'Price must be between $0 and $999,999.',

    acquisitionfees: 'Must be between $0 and $999,999.',
    governmentfees: 'Must be between $0 and $999,999.',

    requestedapr: 'Must be between 0% and 99.99%, with no more than 4 digits total and no more than 2 decimal places.',
    msrp: 'Must be between $1 and $999,999.',
    term: 'Must be between 1 and 99 months.',
    vehiclesellingprice: 'Must be between $1 and $999,999.',
    salestax: 'Must be between $0 and $99,999.'
};
